"use client";

import * as LabelPrimitive from "@radix-ui/react-label";
import type * as React from "react";

import { cn } from "@/lib/cn";

function Label({
  className,
  ...properties
}: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      className={cn(
        "sdkui:flex sdkui:select-none sdkui:items-center sdkui:gap-2 sdkui:font-medium sdkui:text-sm sdkui:leading-none peer-disabled:sdkui:cursor-not-allowed peer-disabled:sdkui:opacity-50 group-data-[disabled=true]:sdkui:pointer-events-none group-data-[disabled=true]:sdkui:opacity-50",
        className
      )}
      data-slot="label"
      {...properties}
    />
  );
}

export { Label };
